import userProfileSlice from './slice';

const userProfileReducer = userProfileSlice.reducer;

export default userProfileReducer;
